// External imports
import { SVGProps } from "react";

export default function ChevronIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 -960 960 960"
      color="#000"
      {...props}
    >
      <path
        fill="currentColor"
        d="M504-480 320-664l56-56 240 240-240 240-56-56 184-184Z"
      />
    </svg>
  );
}
